var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-stack h-stretch gap-3"},[_c('div',[_vm._v("Tasks")]),_c('div',[_vm._v("Not implemented")])])
}]

export { render, staticRenderFns }